import type { IconName } from '@core/user-interface-legacy';

const DEFAULT_ICONS_MAP: Record<string, IconName> = {
  jobs: 'work',
  candidates: 'people',
  pipelines: 'pipeline',
  disqualifications: 'block',
  hires: 'hired',
  interviews: 'calendar-blank',
  evaluations: 'thumbs-up-down',
  careers_site: 'nav-careershub',
  candidate_overview: 'people',
  'pipeline-insights': 'pipeline',
  candidate_disqualifications: 'block',
  job_overview: 'work',
  events_and_evaluations: 'thumbs-up-down',
};

export const getDashboardFallbackIcon = (dashboard: {
  templateId: string | undefined | null;
}): IconName => {
  if (!dashboard.templateId) {
    return 'dashboard';
  }
  return DEFAULT_ICONS_MAP[dashboard.templateId] ?? 'dashboard';
};
